import React from 'react';
import { useTranslation } from 'react-i18next';

const GlobalMessage = ({ title, content, onClose }) => {
  const { t } = useTranslation("login");
  if (!title && !content) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col justify-end bg-black/40 backdrop-blur-sm">

      {/* Клик по затемнению */}
      <div className="absolute inset-0" onClick={onClose} />

      {/* Bottom sheet */}
      <div
        className="
          relative w-full max-h-[85vh]
          bg-white rounded-t-2xl
          px-4 pt-4 pb-[calc(env(safe-area-inset-bottom)+16px)]
          overflow-y-auto
          animate-slide-up
        "
      >
        {/* Хэндл как в Telegram */}
        <div className="w-10 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />

        {/* Заголовок */}
        {title && (
          <h2 className="text-lg font-semibold text-gray-900 mb-3">
            {title}
          </h2>
        )}

        {/* Контент */}
        {content && (
          <div
            className="
              text-sm text-gray-700 leading-relaxed
              [&_p]:mb-3
              [&_a]:text-blue-500
              [&_a]:underline
            "
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}

        {/* Кнопка */}
        <button
          onClick={onClose}
          className="
            mt-4 w-full
            bg-blue-500 text-white
            py-3 rounded-xl
            text-sm font-medium
            active:scale-[0.98]
          "
        >
          {t("ACCEPT")}
        </button>
      </div>
    </div>
  );
};

export default GlobalMessage;